import { History } from 'lucide-react';
import { Button } from '../ui/button';
import type { Draft } from '../../lib/frontDoor/draft';
import { pickedLookName } from '../../lib/frontDoor/looks';

export function ResumeBanner({ draft, onStart, onDiscard }: { draft: Draft; onStart: () => void; onDiscard: () => void }) {
  const look = pickedLookName(draft.look);
  return (
    <div data-clarity-mask="True" className="mb-4 flex flex-col gap-3 rounded-2xl border border-primary/20 bg-primary/5 p-4 sm:flex-row sm:items-center">
      <History className="hidden h-5 w-5 shrink-0 text-primary sm:block" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground">Pick up where you left off</p>
        <p className="truncate text-sm text-muted-foreground">
          {draft.prompt}
          {look ? ` · ${look}` : ''}
        </p>
      </div>
      <div className="flex gap-2">
        <Button type="button" size="sm" onClick={onStart} className="studio-ai-button">
          Start
        </Button>
        <Button type="button" size="sm" variant="ghost" onClick={onDiscard}>
          Discard
        </Button>
      </div>
    </div>
  );
}
